import React, { useState, ChangeEvent, FC, useEffect } from 'react';

interface MonthlyMobileDataProps {
  alarm: any;
  onChange: (newMetrics: any) => void;
}

const MonthlyMobileData: FC<MonthlyMobileDataProps> = ({ alarm, onChange }) => {
  const [dataLimitMb, setDataLimitMb] = useState<number>(0);  // Default value

  useEffect(() => {
    if (alarm !== "") {
      setDataLimitMb(alarm.monthly_data_limit_mb);  // Fallback to default if no value
    }
  }, [alarm]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = parseInt(event.target.value, 10);
    setDataLimitMb(value);
    onChange({ type: "MonthlyMobileData", monthly_data_limit_mb: value });
  };

  return (
    <div className="input-group col-md-4 col-sm-4">
      <input
        className="form-control input-sm"
        name="monthly_mobile_data_limit"
        min={0}
        value={dataLimitMb}
        placeholder="Monthly Mobile Data Limit"
        type="number"
        size={10}
        maxLength={20}
        onChange={handleInputChange}
      />
      <span style={{ paddingLeft: 10 }} className="input-group-addon">MB</span>
    </div>
  );
};

export default MonthlyMobileData;
